/*
  Winkelmandje-herstel (Claude, okt 2026)
  Shopify geeft een regel in het winkelmandje soms een nieuwe sleutel, bv. wanneer een korting zoals
  "2e aan halve prijs" op een ander stuk overspringt. Klikt de klant daarna op aanpassen of verwijderen met de
  oude sleutel, dan antwoordt Shopify "geen geldige ID of regelnummer". Dit script vangt dat op: het haalt het
  actuele winkelmandje op, zoekt dezelfde variant terug en voert de wijziging opnieuw uit met de nieuwe sleutel.
*/
(function () {
  if (!window.fetch || window.__btolCartHerstel) return;
  window.__btolCartHerstel = true;

  var origineel = window.fetch.bind(window);

  function isChange(url) {
    return typeof url === 'string' && /\/cart\/change(\.js)?(\?|$)/.test(url);
  }

  function leesBody(body) {
    if (typeof body === 'string') {
      try { return { soort: 'json', data: JSON.parse(body) }; } catch (e) { /* geen JSON */ }
      return { soort: 'params', data: new URLSearchParams(body) };
    }
    if (body instanceof URLSearchParams) return { soort: 'params', data: new URLSearchParams(body.toString()) };
    if (typeof FormData !== 'undefined' && body instanceof FormData) return { soort: 'form', data: body };
    return null;
  }

  function haalId(b) {
    if (!b) return null;
    if (b.soort === 'json') return b.data.id;
    return b.data.get('id');
  }

  function zetId(b, id) {
    if (b.soort === 'json') { b.data.id = id; return JSON.stringify(b.data); }
    if (b.soort === 'params') { b.data.set('id', id); return b.data.toString(); }
    var f = new FormData();
    b.data.forEach(function (v, k) { f.append(k, k === 'id' ? id : v); });
    return f;
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!isChange(url) || !init || !init.body) return origineel(input, init);

    var b = leesBody(init.body);
    var id = haalId(b);
    if (!id || String(id).indexOf(':') === -1) return origineel(input, init);

    return origineel(input, init).then(function (antwoord) {
      if (antwoord.status !== 400 && antwoord.status !== 422) return antwoord;
      var variant = String(id).split(':')[0];
      return origineel((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var regel = (cart.items || []).filter(function (it) { return String(it.variant_id) === variant; })[0];
          if (!regel || regel.key === id) return antwoord;
          var nieuw = Object.assign({}, init, { body: zetId(b, regel.key) });
          return origineel(input, nieuw);
        })
        .catch(function () { return antwoord; });
    });
  };
})();
